import { useEffect } from 'react';

export default function useScrollToTop() {
  useEffect(() => {
    window.scrollTo(0, 0); // Ensure view is properly positioned when entering e.g. from the bottom of the landing page
  }, []);
}